<template>
  <div>
    <section class="bottomArea">
      <p class="companyName"></p>
      <div class="appInfo">
        <p class="appName">启航教育APP</p>
        <p class="appDescription">免费下载课程视频，听课更流畅</p>
      </div>
      <button @click="goApp" class="goApp">前往APP</button>
    </section>
    <WxShare ref="share" />
  </div>
</template>

<script>
import WxShare from '../../pages/arkHome/components/wxShre.vue';

export default {
  components: {
    WxShare,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    goApp() {
      if (this.$root.isWeiXin) {
        this.$refs.share.show = true;
        return;
      }
      const ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) === 'micromessenger') {
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          window.location = 'https://itunes.apple.com/cn/app/id1172161344';
        } else if (navigator.userAgent.match(/android/i)) {
          window.location = 'https://url.cn/5vh6X3Z';
        }
      } else {
        const loadDateTime = Date.now();
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
          window.location = 'iqihanglmh5://';
          const turnIOS = setTimeout(() => {
            const timeOutDateTime = Date.now();
            if (timeOutDateTime - loadDateTime < 2200) {
              window.location.href = 'https://itunes.apple.com/cn/app/id1172161344';
            } else {
              clearTimeout(turnIOS);
            }
          }, 2000);
        } else if (navigator.userAgent.match(/android/i)) {
          window.location = 'https://url.cn/5vh6X3Z';
        }
      }
    },
  },
};
</script>

<style type="text/css" lang="scss" scoped>
.bottomArea {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  width: 100%;
  height: 109px;
  background: #fefffe;
  box-shadow: 0 -4px 7px 0 rgba(0, 0, 0, 0.05);

  .companyName {
    width: 161px;
    height: 49px;
    margin: -10px 22px 0 24px;
    background: url('../../assets/img/footer/footer_icon.png') no-repeat center center;
    background-size: contain;
  }

  .appInfo {
    .appName {
      height: 36px;
      margin-bottom: 7px;
      color: #333;
      font-weight: 500;
      font-size: 25px;
      line-height: 36px;
    }

    .appDescription {
      height: 31px;
      color: #787878;
      font-weight: 400;
      font-size: 22px;
      line-height: 31px;
    }
  }

  .goApp {
    position: absolute;
    top: 20px;
    right: 36px;
    width: 149px;
    height: 68px;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 68px;
    text-align: center;
    background: #ff6c02;
    border-radius: 34px;
    cursor: pointer;

    &:active {
      background: #ff984d;
    }
  }
}
</style>
